import { palette, rgba } from '@aegislab/design-tokens';

export const stateColorTokens = {
  success: {
    ringBorder: rgba(palette.green, 0.5),
    ringBg: rgba(palette.green, 0.06),
    ringColor: rgba(palette.green, 0.9),
    ringShadow: `0 0 5px ${rgba(palette.green, 0.2)}, inset 0 0 5px ${rgba(palette.green, 0.06)}`,
    hoverBorder: rgba(palette.green, 0.8),
    hoverBg: rgba(palette.green, 0.12),
    hoverShadow: `0 0 10px ${rgba(palette.green, 0.3)}, inset 0 0 8px ${rgba(palette.green, 0.1)}`,
    workingBorder: rgba(palette.green, 0.3),
    workingBg: rgba(palette.green, 0.08),
    workingColor: rgba(palette.green, 0.6),
    workingShadow: `0 0 4px ${rgba(palette.green, 0.1)}, inset 0 0 4px ${rgba(palette.green, 0.03)}`,
    labelIdle: rgba(palette.green, 0.7),
    labelWorking: rgba(palette.green, 0.5),
    popoverText: rgba(palette.green, 0.9),
    popoverHoverBg: rgba(palette.green, 0.1),
    textShadowSm: `0 0 6px ${rgba(palette.green, 0.4)}`,
    textShadowMd: `0 0 10px ${rgba(palette.green, 0.6)}`,
    surface: rgba(palette.green, 0.06),
    light: rgba(palette.green, 0.08),
    strong: rgba(palette.green, 0.15),
    border: rgba(palette.green, 0.3),
    borderSubtle: rgba(palette.green, 0.2),
    glow: `0 0 15px ${rgba(palette.green, 0.15)}`,
    hoverGlow: `0 2px 8px ${rgba(palette.green, 0.2)}`,
  },
  warning: {
    ringBorder: rgba(palette.amber, 0.4),
    ringBg: rgba(palette.amber, 0.06),
    ringColor: rgba(palette.amber, 0.7),
    ringShadow: `0 0 4px ${rgba(palette.amber, 0.12)}, inset 0 0 4px ${rgba(palette.amber, 0.03)}`,
    labelText: rgba(palette.amber, 0.5),
    popoverText: rgba(palette.amber, 0.9),
    popoverHoverBg: rgba(palette.amber, 0.1),
    light: rgba(palette.amber, 0.08),
    strong: rgba(palette.amber, 0.15),
    border: rgba(palette.amber, 0.3),
    hover: rgba(palette.amber, 0.25),
    glow: `0 0 15px ${rgba(palette.amber, 0.15)}`,
    hoverGlow: `0 2px 8px ${rgba(palette.amber, 0.2)}`,
  },
  error: {
    popoverText: rgba(palette.red, 0.9),
    popoverHoverBg: rgba(palette.red, 0.1),
    textShadowSm: `0 0 6px ${rgba(palette.red, 0.4)}`,
    surface: rgba(palette.red, 0.06),
    light: rgba(palette.red, 0.1),
    strong: rgba(palette.red, 0.15),
    border: rgba(palette.red, 0.3),
    borderSubtle: rgba(palette.red, 0.15),
    glow: `0 2px 8px ${rgba(palette.red, 0.2)}`,
  },
  gold: {
    bannerBg: rgba(palette.gold, 0.06),
    bannerBorder: rgba(palette.gold, 0.12),
    bannerBorderStrong: rgba(palette.gold, 0.2),
    topLineGradient: `linear-gradient(90deg, transparent, ${rgba(palette.gold, 0.4)}, transparent)`,
    topRowGradient: `linear-gradient(90deg, ${rgba(palette.gold, 0.08)} 0%, ${rgba(palette.gold, 0.02)} 100%)`,
    scenarioBannerGradient: `linear-gradient(180deg, ${rgba(palette.gold, 0.08)} 0%, ${rgba(palette.gold, 0.02)} 100%)`,
    scenarioLineGradient: `linear-gradient(90deg, transparent 0%, ${rgba(palette.gold, 0.375)} 50%, transparent 100%)`,
    crownFilter: `drop-shadow(0 0 4px ${rgba(palette.gold, 0.5)})`,
    labelColor: rgba(palette.gold, 0.7),
    nameColor: rgba(palette.gold, 0.95),
    messageColor: rgba(palette.gold, 0.9),
    nameShadow: `0 0 8px ${rgba(palette.gold, 0.4)}, 0 0 16px ${rgba(palette.gold, 0.2)}`,
    earningsShadow: `0 0 8px ${rgba(palette.gold, 0.3)}`,
    scenarioLabelShadow: `0 0 10px ${rgba(palette.gold, 0.5)}, 0 0 20px ${rgba(palette.gold, 0.5)}`,
    scenarioMessageShadow: `0 0 10px ${rgba(palette.gold, 0.5)}`,
  },
  info: {
    progressTrackBg: rgba(palette.blue, 0.1),
    progressShadow: `0 0 4px ${rgba(palette.blue, 0.3)}`,
    selectGlowSm: `0 0 6px ${rgba(palette.blue, 0.06)}`,
    light: rgba(palette.blue, 0.1),
    surface: rgba(palette.blue, 0.15),
    border: rgba(palette.blue, 0.3),
  },
  pending: {
    surface: rgba(palette.violet, 0.15),
    border: rgba(palette.violet, 0.3),
  },
} as const;

export type StateColorTokens = typeof stateColorTokens;
